import { memo, useEffect, useState } from "react";
import "./latetimer.scss";
import { IoTime } from "react-icons/io5";

interface PropData {
    reservedDate: string;
    reservedTime: string;
}

function formatToISO(dateStr: string) {
    const [day, month, year] = dateStr.split("/");
    return `${year}-${month}-${day}`;
}

const LateTimerComponent = ({ reservedDate, reservedTime }: PropData) => {
    const [elapsed, setElapsed] = useState("");

    useEffect(() => {
        const formattedDate = formatToISO(reservedDate);
        const [y, m, d] = formattedDate.split("-").map(Number);
        const [hh, mm, ss] = reservedTime.split(":").map(Number);

        const target = new Date(y, m - 1, d, hh, mm, ss || 0).getTime();

        const updateTimer = () => {
            const now = Date.now();
            const diff = now - target;

            if (diff > 0) {
                const hrs = Math.floor(diff / 3600000);
                const mins = Math.floor((diff % 3600000) / 60000);
                const secs = Math.floor((diff % 60000) / 1000);

                setElapsed(
                    hrs > 0 ? `${hrs}h ${mins}m ${secs}s late` : `${mins}m ${secs}s late`
                );
            } else {
                setElapsed("-");
            }
        };

        updateTimer();
        const interval = setInterval(updateTimer, 1000);

        return () => clearInterval(interval);
    }, [reservedDate, reservedTime]);

    return (
        <div className="d-flex">
            <IoTime size={18} className="me-2 text-danger" />
            <span className="late-timer-label">{elapsed}</span>
        </div>
    );
};

// ✅ Memo to prevent re-renders if props don't change
const LateTimer = memo(LateTimerComponent);

export default LateTimer;
